import { createSchema, morphism } from 'morphism';

const defaultOptions = { undefinedValues: { strip: true } };

const paymentMethodsMeta = createSchema(
  {
    houseAccountNumber: 'houseAccountNumber',
    firstName: 'firstName',
    lastName: 'lastName',
    poNumber: 'poNumber',
    costCenter: 'costCenter',
    isMultiCCEnabled: 'isMultiCCEnabled',
    isSingleCCEnabled: 'isSingleCCEnabled'
  },
  defaultOptions
);

const paymentMethodsGetArray = createSchema(
  {
    id: '_id',
    meta: source => morphism(paymentMethodsMeta, source.meta),
    type: 'type',
    provider: 'provider',
    name: 'name',
    code: 'code',
    active: 'active'
  },
  defaultOptions
);

const userMeta = createSchema(
  {
    organizations: 'organizations',
    organization: 'organization',
    deleted: 'deleted',
    code: 'code',
    email: 'email',
    firstName: 'firstName',
    lastName: 'lastName',
    confirmed: 'confirmed',
    provider: 'provider',
    selectedOrganizationCode: 'selectedOrganizationCode',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    phone: 'phone.number',
    companyName: 'companyName',
    status: 'status',
    role: 'role',
    invite: 'invite',
    onboardingState: {
      recognition: 'status.hasWalkedThrough.recognition',
      isCompletedFirstTour: 'status.hasWalkedThrough.isCompletedFirstTour',
      automation: 'status.hasWalkedThrough.automation'
    },
    meta: {
      isPunchoutUser: 'meta.isPunchoutUser',
      isWelcomeModalOpened: 'meta.isWelcomeModalOpened'
    }
  },
  defaultOptions
);

const organizations = createSchema({
  code: 'code',
  displayName: 'displayName',
  name: 'name',
  role: 'role',
  website: 'website'
});

const organizationUserSchema = createSchema({
  id: '_id',
  code: 'code',
  email: 'email',
  firstName: 'firstName',
  invite: 'invite',
  merchantCode: 'merchantCode',
  lastName: 'lastName',
  role: 'role',
  status: 'status'
});

export default {
  getUserData: createSchema(userMeta, defaultOptions),
  getOrganizationUsers: createSchema(
    {
      docs: source => morphism(organizationUserSchema, source.docs),
      pagination: {
        limit: 'limit',
        page: 'page',
        pages: 'totalPages',
        total: 'totalDocs'
      }
    },
    defaultOptions
  ),
  signInWithCode: createSchema(
    {
      token: 'token',
      organizations: source => morphism(organizations, source.organizations),
      user: source => morphism(userMeta, source.user)
    },
    defaultOptions
  ),
  getPaymentMethods: createSchema(
    {
      id: '_id',
      paymentMethods: source => morphism(paymentMethodsGetArray, source.paymentMethods)
    },
    defaultOptions
  ),
  setBranding: createSchema(
    {
      branding: 'branding'
    },
    defaultOptions
  ),
  uploadAsset: createSchema(
    {
      cdnUrl: 'cdnUrl'
    },
    defaultOptions
  )
};
